import { library, dom } from '@fortawesome/fontawesome-svg-core';
import { faChevronDown as farChevronDown } from '@fortawesome/pro-regular-svg-icons';
import { faComment as fasComment } from '@fortawesome/pro-solid-svg-icons';
import { faSpinnerThird as fasSpinnerThird, faQuoteLeft as fasQuoteLeft } from '@fortawesome/pro-solid-svg-icons';
import { faCoffee } from '@fortawesome/free-solid-svg-icons';
import { faHeadset } from '@fortawesome/free-solid-svg-icons';
import { faEnvelope } from '@fortawesome/free-solid-svg-icons';
/**
 * @description This function will be used to load our font aweseome library with
 * all the font awesome icon definitions, which we can then use throughout our app with
 * the @fortawesome/react-fontawesome component.
 */
export default function createFontAwesomeLibrary() {
  library.add(farChevronDown, fasComment, fasSpinnerThird, faCoffee, faHeadset, faEnvelope, fasQuoteLeft);
}
dom.watch();
